
import React,{useCallback,useEffect,useRef,useState} from 'react'
import { ForceGraph2D } from 'react-force-graph';

import { IContext, TextContext } from '../../hooks/context';
// import THREE from "th"
const ForceGraphs = () => {
    const fgRef = useRef();
    const {address,
        outgoingTransaction,
        incomingTransaction,
        outgoingTransaction2,
        incomingTransaction2,
        pars,
        ID,
        setID,
        maxIndex,
        setMaxIndex,
        setPars,
        nodes,
        links,
        setChild} = React.useContext(TextContext) as IContext
      // @ts-ignore
        fgRef?.current?.d3Force('link').distance(link => 60);


function genRandomTree(){
return {
  nodes,links
}
}
      function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
      function nodePaint({ id, x, y,data }, color, ctx) {
        // ctx.fillStyle = color;
        
        let base_image = new Image();
        [
          () => { 
                      ctx.fillStyle="#41134A"
            ctx.beginPath();
            ctx.arc(x , y ,9, 0, 2 * Math.PI);
            // ctx.stroke();
            ctx.fill()

          
          }, // rectangle
          // write a function to draw star
          () => {
            ctx.beginPath();
            ctx.fillStyle = color;
  
            for(let i=0;i<5*2;i++){
              let rotation = Math.PI*2*0.25;
              let angle = (i/(5*2))*Math.PI*2+rotation;
              let dist = 5*(i%2)+5;
              let starX = x+Math.cos(angle)*dist;
              let starY = y+Math.sin(angle)*dist;
              if(i === 0) {
                ctx.moveTo(starX, starY);
                continue; //skip
              }
              ctx.lineTo(starX, starY);
            }
            ctx.closePath();
  ctx.fill();
  ctx.font = '3px Sans-Serif'; 
  ctx.textAlign = 'center'; 
  ctx.textBaseline = 'middle'; 
  ctx.fillText(numberWithCommas(data?.value ?? 0), x, y+10);
          },

          
          () => {  
            ctx.beginPath(); 
            let base_image = new Image();
            base_image.src = '/img.png';
            base_image.onload = function(){
              ctx.drawImage(base_image,x , y,2200,3400);
          
            }
            ctx.fillStyle = "white";
            ctx.moveTo(x, y - 5); 
            ctx.lineTo(x - 5, y + 5); 
            ctx.lineTo(x + 5, y + 5); 
            ctx.fill(); 
            ctx.font = '3px Sans-Serif'; 
            ctx.textAlign = 'center'; 
            ctx.textBaseline = 'middle'; 
            ctx.fillText("unicorn", x, y+7);
            
            // draw image in canvas
          }
        ][data?.unicorn ? 2 : id===1500 ? 0 :1]();
      }

      const getColor = n => n ==="in" ?  "#41134A" : n==="out" ? "#FF5300":"black";

      const handleClick = useCallback(node => {
        // Aim at node from outside it
     
        setChild(node.data.fullName)
        if(pars.find(x=>x===node.data.fullName)){
          setPars((prev)=>[...prev,node.data.fullName])
        }
        
        setID(node.id)
        
      }, [fgRef]);
      useEffect(()=>{
        genRandomTree()
      },[incomingTransaction,incomingTransaction2,outgoingTransaction,outgoingTransaction2])

  return (
    <div style={{width:"100%"}}> 
      
 <ForceGraph2D
          //  width={window.innerWidth-150}
            ref={fgRef}
            maxZoom={2}
            minZoom={0.5}
            width={450}
            height={window.innerHeight-150}
        graphData={genRandomTree()}
      nodeAutoColorBy={'group'}
      linkDirectionalParticles={7}
      // @ts-ignore
      linkDirectionalParticleWidth={(node)=>node.click ? 9: 2.4}
      onNodeClick={handleClick}
        // @ts-ignore
        linkDirectionalArrowLength={(node)=>node.click ? 15:8}
        // @ts-ignore
        nodeCanvasObject={(node, ctx) => nodePaint(node, getColor(node.type), ctx)}
        nodePointerAreaPaint={nodePaint}
        // @ts-ignore
        nodeLabel={'shortName'}
           // @ts-ignore
        linkDirectionalParticleColor={(node) =>node.type === "in" ? "#41134A" :"#FF5300" }
           // @ts-ignore
        linkDirectionalArrowColor={(node) =>node.type === "in" ? "#41134A" :"#FF5300" }
      />

    
          
    
    </div>
  )
}

export default ForceGraphs